import React from 'react';
import { motion } from 'framer-motion';
export interface PollOption {
  id: string;
  label: string;
  percent: number;
}
interface PeerPollProps {
  options: PollOption[];
  userChoice?: string;
}
export function PeerPoll({
  options,
  userChoice
}: PeerPollProps) {
  const userOption = options.find(o => o.id === userChoice);
  const userPercent = userOption?.percent ?? 0;
  if (!userOption) return null;
  return <div className="w-full flex flex-col gap-4" data-id="element-81">
      <div className="flex flex-col gap-1" data-id="element-82">
        <h3 className="text-sm font-bold text-slate-900" data-id="element-83">
          See how you compared to your peers
        </h3>
      </div>

      <motion.div initial={{
      opacity: 0,
      x: -10
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      duration: 0.4,
      delay: 0.2
    }} className="flex flex-col gap-2.5" data-id="element-84">
        <div className="flex justify-between items-end" data-id="element-85">
          <span className="text-xs font-medium text-slate-900 flex items-center gap-1.5 pb-0.5" data-id="element-86">
            <span className="w-1.5 h-1.5 rounded-full bg-minerva-blue shadow-[0_0_6px_rgba(0,133,189,0.6)]" data-id="element-87" />
            {userOption.label}
          </span>
          <div className="flex flex-col items-end leading-none" data-id="element-88">
            <motion.span initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.6
          }} className="text-2xl font-display font-bold text-minerva-blue tabular-nums" data-id="element-89">
              {userPercent}%
            </motion.span>
            <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider mt-1" data-id="element-90">
              answered like you
            </span>
          </div>
        </div>
        <div className="h-2.5 w-full bg-slate-100 rounded-full overflow-hidden" data-id="element-91">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: `${userPercent}%`
        }} transition={{
          duration: 1.2,
          delay: 0.3,
          ease: 'easeOut'
        }} className="h-full rounded-full bg-gradient-to-r from-minerva-blue to-minerva-cyan shadow-[0_0_10px_rgba(0,133,189,0.4)]" data-id="element-92" />
        </div>
      </motion.div>
    </div>;
}